// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".welcome-dialog .welcome-list {\n  padding: 6px 0;\n  margin: 0;\n  max-height: 450px;\n  overflow: auto;\n}\n.welcome-dialog .welcome-list .welcome-item {\n    padding: 8px;\n    border-width: 1px 0px;\n    border-style: solid;\n    border-color: #dcdfe6;\n    margin-bottom: 6px;\n    cursor: pointer;\n}\n.welcome-dialog .welcome-list .welcome-item:hover {\n    background: #d0f1ff;\n}\n.welcome-dialog .welcome-list .welcome-select {\n    background: #d0f1ff;\n}\n", ""]);
// Exports
module.exports = exports;
